<template>
    <nav class="navigation">
      <div class="navigation-title" :class="{'navigation-title-collapsed': visible === false}" @click="toggle">
        <h1><span>{{$root.t('menu_brand')}}</span></h1>
      </div>
      <div class="navigation-tray" :class="{'navigation-tray-visible': visible === true}">
        <div class="navigation-tray-header">
          <a @click="current = 'issues'" :class="{'active': current == 'issues'}">{{$root.t('menu_issues')}}</a>
          <a @click="current = bk" v-for="(b, bk) in about" :class="{'active': current == bk}" :key="`bl-${b._id}`" v-html="b._name"/>
        </div>
        <transition name="fade" mode="out-in">
          <div class="navigation-page" :key="current">
            <template v-if="current == 'issues'">
              <div class="book-container" v-for="b in $root.books" :key="`bl-${b.Id}`">
                <a class="book-container-title" v-on:click="toggle({name: 'book', params: {bookId: b.Id, stub: b.Stub}})">
                  <div class="book-container-title-left" v-html="b.Options.Author"/>
                  <div class="book-container-title-right">
                    <p v-html="b.Name"/>
                    <p v-html="b.Options.Subtitle"/>
                  </div>
                </a>
                <div class="book-container-links">
                  <a v-if="b.data && b.data.StoreLink" :href="b.data.StoreLink" target="_blank">↗&nbsp;{{$root.t('menu_buy')}}</a>
                  <a v-else class="inactive">↗&nbsp;{{$root.t('menu_buy')}}</a>
                  <a v-if="b.data && b.data.PdfLink" :href="b.data.PdfLink" target="_blank">&darr;&nbsp;{{$root.t('menu_pdf')}}</a>
                  <a v-else-if="b.data && b.data.PDF && b.data.PDF[0]" :href="b.data.PDF[0].Original" target="_blank">&darr;&nbsp;{{$root.t('menu_pdf')}}</a>
                  <a v-else class="inactive">&darr;&nbsp;{{$root.t('menu_pdf')}}</a>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="about-container">
                <div class="about-container-left" v-html="about[current].ContainerLeft"/>
                <div class="about-container-right" v-html="about[current].ContainerRight"/>
              </div>
              <div class="about-logo" v-if="logo">
                <img :src="logo"/>
              </div>
            </template>
          </div>
        </transition>
      </div>
    </nav>
</template>

<script>

export default {
  name: 'Navigation',
  methods: {
    toggle (route) {
      this.$root.$emit('navigation-opened', !this.visible)
      if (route) {
        this.$router.push(route)
      }
    }
  },
  data () {
    return {
      about: false,
      visible: false,
      current: 'issues'
    }
  },
  computed: {
    logo () {
      try {
        return this.about[this.current].Logo[0].Original
      } catch (err) {
        return false
      }
    }
  },
  async mounted () {
    this.about = this.$root.about
    this.$root.$on('context-opened', (e) => {
      if (e === true) this.visible = false
    })
    this.$root.$on('extra-opened', (e) => {
      if (e.visible === true) this.visible = false
    })
    this.$root.$on('navigation-opened', (e) => {
      this.$root.overlay = e
      this.visible = e
    })
  }
}
</script>

<style lang="scss">

@import '../main';

.navigation {
  left: 0px;
  z-index: 2002;
  &-tray {
    background: var(--navigation-color);
    width: var(--navigationwidth);
    left: 0px;
    transform: translateX(-100%);
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    @include tocfont;
    &-header {
      text-transform: uppercase;
      position: sticky;
      z-index: 11;
      top: 0px;
      left: 0px;
      right: 0px;
      padding: var(--padding) calc(var(--menuwidth-hidden) + var(--padding));
      @include sm() {
        padding: var(--padding-05) calc(var(--menuwidth-hidden) + var(--padding-05)) var(--padding);
      }
      a {
        margin-right: var(--padding);
        cursor: pointer;
        color: #ADADAD;
        &.active {
          color: black;
        }
      }
      &:before {
        content: "";
        position: absolute;
        background: #FFF;
        width: 100%;
        left: 0px;
        top: 0px;
        bottom: var(--padding-05);
        z-index: -1;
      }
    }
  }
  &-title {
    left: 0px;
    background: var(--navigation-color);
    transition: var(--nav-hoover-anim);
    &-collapsed {
      @include hover() {
        transform: translateX(0);
      }
    }
  }
  &-page {
    display: flex;
    flex-direction: column;
    min-height: calc(100% - var(--menuwidth-hidden) - var(--padding)  - var(--padding-05));
    padding-top: var(--padding-05);
    @include sm() {
      padding-top: 0 !important;
    }
    padding-bottom: var(--padding);
    box-sizing: border-box
  }
  .about-container {
    @include sidemenufont();
    margin-left: var(--menuwidth-hidden);
    display: flex;
    font-weight: normal;
    letter-spacing: 0;
    margin-top: calc(-1 * var(--padding-05));
    &-left,
    &-right {
      width: 50%;
      box-sizing: border-box;
      padding: 0 var(--padding);
      @include sm() {
        width: 100%;
        padding: var(--padding-05) var(--padding-05) 0 var(--padding-05);
      }
      a:before {
        content: "↗\00a0";
      }
    }
    @include sm() {
      display: block;
    }
    &-left {
      hyphens: auto;
    }
    &-right {
      @include sm() {
        padding-top: var(--padding-20);
      }
    }
  }
  .about-logo {
    margin-left: calc(var(--menuwidth-hidden) + var(--padding));
    @include sm() {
      margin-left: calc(var(--menuwidth-hidden) + var(--padding-025));
    }
    flex-grow: 4;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    img {
      max-width: 25%;
      width: 8rem;
    }
  }
  .book-container {
    margin-left: calc(var(--padding) + var(--menuwidth-hidden));
    margin-right: var(--padding-20);
    padding: var(--padding) 0;
    @include sm() {
      margin-left: calc(var(--padding-05) + var(--menuwidth-hidden));
      margin-right: var(--padding);
    }
    border-top: 1px solid #ADADAD;
    position: relative;
    display: flex;
    text-transform: uppercase;
    &-title {
      display: flex;
      flex-grow: 2;
      cursor: pointer;
      p {
        margin: 0;
        padding: 0;
        &:last-child {
          font-style: italic;
          //margin-top: var(--padding-05);
        }
      }
      &-left,
      &-right {
        flex-basis: 50%;
      }
      @include sm() {
        display: block;
        &-left,
        &-right {
          display: block;
          width: 100%;
        }
        &-right {
          margin-top: var(--padding-05);
          p {
            margin-top: 0 !important;
          }
        }
      }
    }
    &-links {
      flex-shrink: 2;
      padding-left: var(--padding-20);
      a {
        display: block;
        white-space: nowrap;
        &:last-child {
          margin-top: var(--padding-05);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue